export const GA_MEASUREMENT_ID = 'G-JNTF95PFFV';

export const analyticsConfigured = GA_MEASUREMENT_ID.length > 0;
